"use client";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PageChallengeSchema } from "@/sanity/pages/PageChallengeTemplate";
import ChipSerif from "@/components/global/ui/ChipSerif";
import checkbox from "@/public/challenge/checkbox.svg";
import { motion } from "framer-motion";
import FAQList from "@/components/global/ui/FAQList";
import { PortableTextBlock } from "sanity";
import { PageAffiliateSchema } from "@/sanity/pages/PageAffiliateTemplate";
import iqicon from "@/public/affiliate/iqIcon.svg";
import { CTAButton } from "@/shadcn/ui/button";
import { PageTextOnlyLPSchema } from "@/sanity/pages/PageTextOnlyLPTemplate";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/shadcn/ui/carousel";
import Image from "@/helpers/Image";

export default function HistorySection({
  data,
  className,
}: {
  data: PageTextOnlyLPSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative overflow-clip pb-[3rem] lg:pb-[6rem] px-[4rem] lg:px-[6.6rem] w-full",
        className,
      )}
    >
      <div className="w-full flex flex-col items-start relative bg-white">
        {data.historyChip && <ChipSerif text={data.historyChip} />}

        {data.historyText && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="richtext richtext-start prose-h2:font-medium prose-h2:text-[3rem] lg:prose-h2:text-[4rem] lg:prose-h2:mb-[4rem] mb-[0rem] lg:mb-0
            prose-p:text-[1.85rem] lg:prose-p:text-[2.25rem] prose-p:text-[#103037]/80 lg:prose-p:max-w-[54.5rem]"
          >
            <PortableText
              value={data.historyText}
              components={richTextComponent}
            />
          </motion.div>
        )}
      </div>
    </section>
  );
}
